import { Alert } from '@mui/material'
import React from 'react'
import GenerateIcon from './GenerateIcon'

export type alertTypes = "success" | "warning" | "error" | "info"
interface IAlert {
    type: alertTypes,
    message: string
}

export default function AlertElement(props: IAlert) {

    const { type, message } = props

    return <Alert icon={<GenerateIcon icon={type} />} severity={type}>{message}</Alert>
}